import { CollaborationMode } from "./CollaborationBarContext";

/**
 * Persistent storage (currently localStorage) for collaboration bar state.
 */
export const CollaborationBarStorage = {
  /** The width (in pixels) of the collaboration bar. */
  getWidth(): number | null {
    const value = localStorage.getItem("CollaborationBar.width_in_pixels");

    if (value === null) {
      return null;
    }

    const width = Number(value);
    return Number.isFinite(width) ? width : null;
  },

  /** Get the active collaboration mode. Returns null if not set. */
  getActiveMode(): CollaborationMode | null {
    const value = sessionStorage.getItem("CollaborationBar.activeMode");
    if (value === "ai-agent-chat") {
      return value;
    }
    return null;
  },

  /** Set the width of the collaboration bar in pixels. */
  setWidth(value: number): void {
    localStorage.setItem("CollaborationBar.width_in_pixels", value.toString());
  },

  /** Set the active collaboration mode. */
  setActiveMode(value: CollaborationMode | null): void {
    if (value === null) {
      sessionStorage.removeItem("CollaborationBar.activeMode");
    } else {
      sessionStorage.setItem("CollaborationBar.activeMode", value);
    }
  },
};
